import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';
import 'firebase/messaging'

var firebaseConfig = {
    apiKey: "AIzaSyDc8vpJG1SGJF904AKchKAwNDmRjp-F9Zw",
    authDomain: "sanvikafoodzo.firebaseapp.com",
    databaseURL: "https://sanvikafoodzo.firebaseio.com",
    projectId: "sanvikafoodzo",
    storageBucket: "sanvikafoodzo.appspot.com",
    messagingSenderId: "468074973191",
    appId: "1:468074973191:web:94a48a404350e1f11682a2",
    measurementId: "G-P454XEZQ5Q"
};

firebase.initializeApp(firebaseConfig);

let messaging = null;
if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging();
  messaging.usePublicVapidKey(
    // Project Settings => Cloud Messaging => Web Push certificates
    "BHGN4B88rWtTWX09EhAXw9dCM_uB0owTg7Ry3ouiF7LSpoqph8qbwoYB9SGFI0AZTHpRykWE3J4aupNUdo2YrDI"
  );
}

export { messaging };
export default firebase;